// src/routes/transportationsRoutes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import Transportations from '../pages/transportations/Transportations';
import CreateTransportation from '../pages/transportations/CreateTransportation';
import EditTransportation from '../pages/transportations/EditTransportation';
import ProtectedRoute from '../components/global/ProtectedRoute';

const transportationsRoutes = (
    <>
        {/* Transportations List */}
        <Route
            path="/transportations"
            element={
                <ProtectedRoute requiredPermission="transportations_list">
                    <Transportations />
                </ProtectedRoute>
            }
        />

        {/* Transportations Archive */}
        <Route
            path="/transportations/archive"
            element={
                <ProtectedRoute requiredPermission="transportations_archive_list">
                    <Transportations />
                </ProtectedRoute>
            }
        />

        {/* Create Transportation */}
        <Route
            path="/transportations/create"
            element={
                <ProtectedRoute requiredPermission="transportations_create">
                    <CreateTransportation />
                </ProtectedRoute>
            }
        />

        {/* Edit Transportation */}
        <Route
            path="/transportations/:id/edit"
            element={
                <ProtectedRoute requiredPermission="transportations_edit">
                    <EditTransportation />
                </ProtectedRoute>
            }
        />
    </>
);

export default transportationsRoutes;
